// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-ViewInfo-ViewInfo-module__box--KKYfN {
  border-radius: 4px;
  overflow: hidden;
  height: max-content;
  background-color: #fafafa;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-ViewInfo-ViewInfo-module__box--KKYfN .src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-ViewInfo-ViewInfo-module__boxTitle--YSqQ9 {
  padding: 16px 24px;
  font-weight: 700;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  column-gap: 12px;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-ViewInfo-ViewInfo-module__box--KKYfN .src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-ViewInfo-ViewInfo-module__fields--a7yBn {
  padding: 12px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-ViewInfo-ViewInfo-module__box--KKYfN .ant-form-item {
  margin-bottom: 0 !important;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-ViewInfo-ViewInfo-module__divider--FHnNW {
  margin: 0 !important;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-ViewInfo-ViewInfo-module__divider--FHnNW .ant-divider-inner-text {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ManagementPage/Obj2Tab/forms/AttrForm2/MetaInfo/ViewInfo/ViewInfo.module.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AACF;AALA;EAOI,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAbA;EAeI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AAnBA;EAsBI,2BAAA;AAAJ;AAIA;EACE,oBAAA;AAFF;AACA;EAGI,eAAA;AADJ","sourcesContent":[".box {\n  border-radius: 4px;\n  overflow: hidden;\n  height: max-content;\n  background-color: #fafafa;\n\n  .boxTitle {\n    padding: 16px 24px;\n    font-weight: 700;\n    background-color: #f0f0f0;\n    display: flex;\n    align-items: center;\n    column-gap: 12px;\n  }\n  .fields {\n    padding: 12px 24px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n  // Убрать пустое место под элементом формы. Вместо него gap\n  :global(.ant-form-item) {\n    margin-bottom: 0 !important;\n  }\n}\n\n.divider {\n  margin: 0 !important;\n  :global(.ant-divider-inner-text) {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-ViewInfo-ViewInfo-module__box--KKYfN`,
	"boxTitle": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-ViewInfo-ViewInfo-module__boxTitle--YSqQ9`,
	"fields": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-ViewInfo-ViewInfo-module__fields--a7yBn`,
	"divider": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-MetaInfo-ViewInfo-ViewInfo-module__divider--FHnNW`
};
export default ___CSS_LOADER_EXPORT___;
